// index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import i18n from 'i18next';
import App from './App';
import enTranslation from './Locales/en.json';
import hnTranslation from './Locales/hn.json';
import store from './State/store.js'; // Import the Redux store
import CssBaseline from '@mui/material/CssBaseline';
import './Styles/center-single-button.css';

i18n.init({
  interpolation: { escapeValue: false },
  lng: 'en',
  resources: {
    en: {
      translation: enTranslation,
    },
    hn: {
      translation: hnTranslation,
    },
  },
});


const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <CssBaseline />
      <App />
    </I18nextProvider>
  </Provider>,
);
